import { FC } from "react";
import { PrivacyGhost } from "rujira.ui";
import "./PrivateOperationSteps.scss";

/** Takes the place of the spinner while a private action runs. */
export const PrivateToastGhost: FC = () => (
  <PrivacyGhost motion="swirl" className="private-steps__ghost filter-white" />
);

/** A happy hop in place of the check mark once a private action landed. */
export const PrivateToastSuccessGhost: FC = () => (
  <PrivacyGhost
    motion="success"
    className="private-steps__ghost filter-white"
  />
);

/** × eyes and a head shake in place of the cross when a private action failed. */
export const PrivateToastErrorGhost: FC = () => (
  <PrivacyGhost motion="error" className="private-steps__ghost filter-white" />
);
